import { isValidElement, PropsWithChildren, ReactNode } from 'react';
import { AnimatePresence } from 'motion/react';
import { Dialog as Primitive } from 'radix-ui';

import { DialogContext } from '@components/primitives/Dialog/context';
import {
  ModalPartsContext,
  useModalAutoFocus,
} from '@components/primitives/focus';

import { DialogState } from './useDialog';

export interface DialogRootProps<T = void> extends PropsWithChildren {
  state: DialogState<T>;
  trigger?: string | ReactNode;
  modal?: boolean;
}

export function DialogRoot<T = void>({
  state,
  trigger,
  modal,
  children,
}: DialogRootProps<T>) {
  const [triggerRef, parts] = useModalAutoFocus(trigger);

  return (
    <DialogContext.Provider value={state}>
      <ModalPartsContext.Provider value={parts}>
        <Primitive.Root
          open={state.isOpen}
          onOpenChange={state.setIsOpen}
          modal={modal}
        >
          {isValidElement(trigger) && (
            <Primitive.Trigger ref={triggerRef} asChild>
              {trigger}
            </Primitive.Trigger>
          )}

          <AnimatePresence>
            {state.isOpen && (
              <Primitive.Portal forceMount>{children}</Primitive.Portal>
            )}
          </AnimatePresence>
        </Primitive.Root>
      </ModalPartsContext.Provider>
    </DialogContext.Provider>
  );
}
